import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './airport-contact.styles';

const AirportContact = ({ contactDetailsHTML = '', isDweb = false, locName }) => {
  if (!contactDetailsHTML) {
    return null;
  }
  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details className="flexCol">
        <h3>{locName} Airport Contact Info</h3>
        <div dangerouslySetInnerHTML={{ __html: contactDetailsHTML }}></div>
      </S.Details>
    </C.Wrap>
  );
};

export default AirportContact;
